import { IconProps } from './IconProps';
export function TargetCorrectIcon(props: IconProps) {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_803_39071)">
                <path
                    d="M9.5 11.5L14.5 6.5"
                    stroke="#121A44"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.793 3.207C14.6055 3.39449 14.5001 3.64881 14.5 3.914V6.5H17.086C17.3512 6.49994 17.6055 6.39455 17.793 6.207L20.5 3.5H17.5V0.5L14.793 3.207Z"
                    stroke="#121A44"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.4987 16.5C8.57463 16.4998 7.66871 16.2434 6.88149 15.7595C6.09428 15.2756 5.45657 14.583 5.03917 13.7585C4.62176 12.9341 4.44099 12.0101 4.51691 11.0892C4.59283 10.1683 4.92248 9.28637 5.46926 8.54144C6.01604 7.7965 6.75856 7.21766 7.6144 6.86918C8.47024 6.5207 9.40591 6.4162 10.3175 6.56729C11.2292 6.71838 12.0811 7.11915 12.7787 7.72511C13.4764 8.33106 13.9925 9.1185 14.2697 10"
                    stroke="#121A44"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.50185 20.5C8.19326 20.4991 6.90061 20.2129 5.71397 19.6613C4.52733 19.1097 3.47525 18.3059 2.63106 17.3061C1.78687 16.3062 1.17087 15.1343 0.825998 13.8719C0.481122 12.6096 0.415666 11.2873 0.63419 9.99706C0.852715 8.70685 1.34996 7.47982 2.09128 6.40146C2.8326 5.32311 3.80016 4.41939 4.92652 3.75328C6.05288 3.08716 7.31095 2.67469 8.61305 2.54459C9.91515 2.41449 11.23 2.56991 12.4658 3"
                    stroke="#121A44"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.5 17.5C11.5 19.0913 12.1321 20.6174 13.2574 21.7426C14.3826 22.8679 15.9087 23.5 17.5 23.5C19.0913 23.5 20.6174 22.8679 21.7426 21.7426C22.8679 20.6174 23.5 19.0913 23.5 17.5C23.5 15.9087 22.8679 14.3826 21.7426 13.2574C20.6174 12.1321 19.0913 11.5 17.5 11.5C15.9087 11.5 14.3826 12.1321 13.2574 13.2574C12.1321 14.3826 11.5 15.9087 11.5 17.5Z"
                    stroke="#121A44"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.1766 15.7559L17.2716 19.6289C17.207 19.7147 17.1247 19.7857 17.0304 19.8371C16.936 19.8884 16.8317 19.919 16.7246 19.9267C16.6174 19.9343 16.5098 19.919 16.4091 19.8816C16.3084 19.8442 16.2168 19.7856 16.1406 19.7099L14.6406 18.2099"
                    stroke="#121A44"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_803_39071">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
